module.exports = __webpack_public_path__ + "static/img/view2.94efefa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/view2.png
// module id = i+aK
// module chunks = 1